module.exports = __webpack_public_path__ + "static/media/gifts.471e74f2.svg";